import { Degree } from '../../../../../../domain/Degree';
import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class VoltageCosinePhiEvaluation {
  private readonly ruleName = 'Mv_Busbar_VoltageCosinePhi';

  constructor(private readonly ruleProvider: ForRuleProviding) {}

  public evaluate(voltageCosinePhi: number): EvaluationResultType<Degree> {
    const rule = this.ruleProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      voltageCosinePhi
    );
    const value = Degree.fromFloat(voltageCosinePhi);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
